module.exports = __webpack_public_path__ + "static/media/p15.5fa7a0ba.jpeg";